const ItemStatusMap = {
  1: "闲置",
  2: "已装配",
  3: "报废",
  4: '灭失',
}

const ProductStatusMap = {
  1: '装配中',
  2: '已装配',
  3: '已拆卸',
  4: '报废',
  5: '灭失',
}

const NoCodeProductStatusMap = {
  1: '待接收',
  2: '已完成',
  3: '已撤回',
  4: '已拒收',
}

const StockProductStatusMap = {
  1: '启用',
  2: '禁用',
}

const ProductItemStatusMap = {
  1: '待装配',
  2: '已装配',
}

const DrillWellStatusMap = {
  1: '正常',
  100: '已归档',
}

const WarningStatusMap = {
  1: '已预警',
}

const ApplyStatusMap = {
  1: '待提交',
  2: '待审批',
  3: '审批通过',
  4: '审批不通过',
}

const SupplyStatusMap = {
  1: '待提交',
  2: '待接收',
  3: '已接收',
  4: '已拒收',
  5: '接收中',
  6: '已撤回',
}

const SupplyCategoryMap = {
  1: '发货单',
  2: '返货单',
}

const ApplyItemCategoryMap = { //钻具没有出入库操作，所以待定
  // 1: '钻具成品',
  // 2: '钻具配件',
  3: '仪器成品',
  4: '仪器配件'
}


const ProductHourStepMap = {
  "A": "1-100",
  "B": "101-200",
  "C": "201-300",
  "D": "301-400",
  "E": "401-500",
  "F": "501-600",
  "G": "601-700",
  "H": "701-800",
  "I": "801-900",
  "J": "901-1000",
  "K": "1000以上",
}

const DeliveryCategoryMap = {
  1: '快递',
  2: '专车',
  3: '跟车',
  4: '空运',
  5: '入库',
  6: '维修',
}

const ProductWellPeriodStatusMap = {
  0: '-',
  1: '待接收',
  2: '已拒收',
  3: '已接收',
}

export { StockProductStatusMap, NoCodeProductStatusMap, ProductWellPeriodStatusMap, DeliveryCategoryMap, ItemStatusMap, ProductStatusMap, ProductItemStatusMap, DrillWellStatusMap, WarningStatusMap, ApplyStatusMap, SupplyStatusMap, ApplyItemCategoryMap, ProductHourStepMap, SupplyCategoryMap }
